import { ProductDivisionCreatePage } from "@/features/product-division/pages/ProductDivisionCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-division/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_division.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductDivisionCreatePage,
});
